import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
    TgButtons2Module,
    TgGridModule,
    TgInputGroupModule,
    TgInputModule,
    TgLoadingModule
} from '@trademe/tangram';
import { MotorsDescriptionAndPhotosVideoSectionComponent } from './motors-description-and-photos-video-section.component';

@NgModule({
    imports: [
        CommonModule,
        TgGridModule,
        FormsModule,
        TgInputModule,
        TgInputGroupModule,
        TgButtons2Module,
        TgLoadingModule
    ],
    declarations: [MotorsDescriptionAndPhotosVideoSectionComponent],
    exports: [MotorsDescriptionAndPhotosVideoSectionComponent]
})
export class MotorsDescriptionAndPhotosVideoSectionModule {}
